<template>
  <div
    v-if="selectedSite && selectedSite.id"
    class="content"
  >
    <p class="noYPadding mb-0 text">
      {{ $t(`copySite.step2.select`) }}
    </p>
    <v-row>
      <v-col class="noYPadding copySite">
        <VCheckbox
          v-model="data.workOrderType"
          :label="$t('copySite.step2.workOrderType')"
          outlined
          solo
          flat
          hideDetails
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding copySite">
        <VCheckbox
          v-model="data.standards"
          :label="$t('copySite.step2.standards')"
          outlined
          solo
          flat
          hideDetails
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding copySite">
        <VCheckbox
          v-model="data.analysisRequestTemplates"
          :label="$t('copySite.step2.analysisRequestTemplate')"
          outlined
          solo
          flat
          hideDetails
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding copySite">
        <VCheckbox
          v-model="data.controlChart"
          :label="$t('copySite.step2.controlChart')"
          outlined
          solo
          flat
          hideDetails
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
  <div
    v-else
    class="text-center"
  >
    <p class="noYPadding text">
      {{ $t(`copySite.selectSite`) }}
    </p>
  </div>
</template>

<script>
import VCheckbox from '@/components/shared/widgets/forms/VuetifyInputs/VCheckbox.vue';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
    name: 'AnalysesView',
    components: {
        VCheckbox,
    },
    props: {
        analyses: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        ...mapGetters([
            'selectedSite',
        ]),
    },
    watch: {
        analyses: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.analyses) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { analyses: this.data });
        },
    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
    padding-bottom: 0px;
    padding-top: 0px;
}
.text {
    font-size: 18px;
}
.content {
    padding: 0 25%;
}
</style>
